import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

export const ScoringBox = ({ ...props }: ScoringBoxProps): JSX.Element => {
    const [showDetails, setShowDetails] = useState(false);

    return (
        <div className="box is-shadowless">
            <div className="columns" onClick={() => setShowDetails(!showDetails)}>
                <div className="column is-half">
                    <h2 className="title is-6 has-text-ldark-gray extra-bold">{props.title}</h2>
                    {props.isRecall && (
                        <div className="move-up-1 has-text-ldark-gray">
                            <span className="is-inline-block pr-5">Total Recalled: {props.totalWords}</span>
                            <span className="is-inline-block pr-5">Total Correct: {props.totalCorrect}</span>
                            <span className="is-inline-block pr-5">Total Intrusions: {props.totalIncorrect}</span>
                        </div>
                    )}
                    {!props.isRecall && (
                        <div className="move-up-1">
                            <span className="is-inline-block pr-5 has-text-ldark-gray">
                                Total Correct Repeats: {props.totalCorrect}
                            </span>
                            <span className="is-inline-block pr-5">
                                Total Incorrect Repeats: {props.totalIncorrect}
                            </span>
                        </div>
                    )}
                </div>
                <div className="column is-half ">
                    <div className="mb-2 has-text-right">
                        {!showDetails && <FontAwesomeIcon icon={faPlus} size="sm" />}
                        {showDetails && <FontAwesomeIcon icon={faMinus} size="sm" />}
                    </div>
                </div>
            </div>
            {showDetails && (
                <>
                    <div>{props.children}</div>
                </>
            )}
        </div>
    );
};

interface ScoringBoxProps {
    isRecall: boolean;
    children: React.ReactNode;
    totalWords: number;
    totalCorrect: number;
    totalIncorrect: number;
    title: string;
}
